import React, { useState, useEffect } from "react";

import UnifiedSidebar from "../Sidebar/UnifiedSidebar";
import { OrganizationFeaturesProvider } from "../../context/OrganizationFeaturesContext";
import { PermissionsProvider } from "../../context/PermissionsContext";
import { useTournamentId } from "../../context/TournamentRouteContext";

const TournamentLayout = ({ children, className = "" }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const tournamentId = useTournamentId();

  // Handle sidebar collapse state in localStorage
  useEffect(() => {
    const savedState = localStorage.getItem("tournamentSidebarCollapsed");
    if (savedState !== null) {
      setIsSidebarCollapsed(JSON.parse(savedState));
    }
  }, []);

  const handleToggleCollapse = () => {
    const newState = !isSidebarCollapsed;
    setIsSidebarCollapsed(newState);
    localStorage.setItem(
      "tournamentSidebarCollapsed",
      JSON.stringify(newState)
    );
  };

  return (
    <PermissionsProvider>
      <OrganizationFeaturesProvider>
        <div className={`flex min-h-screen bg-brand-cream ${className}`}>
          {/* Sidebar */}
          <UnifiedSidebar
            context="tournament"
            tournamentId={tournamentId}
            isCollapsed={isSidebarCollapsed}
            onToggleCollapse={handleToggleCollapse}
          />

          {/* Main Content */}
          <div className="flex-1 p-3 lg:pb-3 min-w-0 max-w-full">
            <div className="max-w-6xl mx-auto w-full">{children}</div>
            <div
              className="lg:hidden pointer-events-none"
              style={{
                height:
                  "var(--tournament-mobile-clearance, calc(3.5rem + env(safe-area-inset-bottom, 0px)))",
              }}
              aria-hidden="true"
            />
          </div>
        </div>
      </OrganizationFeaturesProvider>
    </PermissionsProvider>
  );
};

export default TournamentLayout;
